import React from 'react';
import { Box, Paper, Typography, Button, Link } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { enterpriseGridOverrideTheme } from '../../themes/EnterpriseGridTheme';
import DescriptionIcon from '@mui/icons-material/Description';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const ClassificationHomeTemp = () => {
  const navigate = useNavigate();

  // Hard‑coded demo data
  const rows = [
    {
      id: 1,
      classificationDateTime: '2025-04-17',
      totalPartNumbers: 1049096,
      updatedParts: 2724,
      updatedPercent: 0.0026, // 0.25%
    },
    {
      id: 2,
      classificationDateTime: '2025-05-15',
      totalPartNumbers: 1049153,
      updatedParts: 1712,
      updatedPercent: 0.00163,
    },
    {
      id: 3,
      classificationDateTime: '2025-06-19',
      totalPartNumbers: 1049202,
      updatedParts: 363,
      updatedPercent: 0.00030,
    },
    {
      id: 4,
      classificationDateTime: '2025-07-17',
      totalPartNumbers: 1049211,
      updatedParts: 635,
      updatedPercent: 0.000605,
    },
    {
      id: 5,
      classificationDateTime: '2025-08-21',
      totalPartNumbers: 1049248,
      updatedParts: 414,
      updatedPercent: .00039,
    },
  ];

  // Create pre-formatted display versions of each value
  const formattedRows = rows.map(row => ({
    id: row.id,
    classificationDateTime: new Date(row.classificationDateTime)
      .toLocaleDateString(undefined, { timeZone: 'UTC' }),
    totalPartNumbers: row.totalPartNumbers.toLocaleString(),
    updatedParts: row.updatedParts.toLocaleString(),
    updatedPercent: `${(row.updatedPercent * 100).toFixed(2)}%`,
    // Keep the original values for any processing you might need
    raw: { ...row }
  }));

  const columns = [
    {
      field: 'classificationDateTime',
      headerName: 'Date',
      width: 200,
    },
    {
      field: 'totalPartNumbers',
      headerName: 'Total Parts',
      width: 150,
    },
    {
      field: 'updatedParts',
      headerName: 'Updated Parts',
      width: 150,
    },
    {
      field: 'updatedPercent',
      headerName: 'Updated %',
      width: 150,
      align: 'right',
      headerAlign: 'right',
    },
  ];

  // SharePoint document link
  const documentLink = "https://itsparts-my.sharepoint.com/:w:/g/personal/zack_watts_its_aero/EZoNnIP28TRInrvhPZGP_M4Bw59snh3iyK_vC505rMdRxw?e=N5PI9F";

  return (
    <Paper elevation={3} sx={{ p: 3, maxWidth: '100%', mt: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h1" component="h1" gutterBottom>
          Part Classifications
        </Typography>

        <Button
          variant="contained"
          color="primary"
          startIcon={<DescriptionIcon />}
          endIcon={<OpenInNewIcon />}
          component={Link}
          href={documentLink}
          target="_blank"
          rel="noopener noreferrer"

        >
          Documentation
        </Button>



      </Box>

      <Box sx={{ height: 500, width: '100%' }}>
        <DataGrid
          density="compact"
          rows={formattedRows}
          columns={columns}
          sx={enterpriseGridOverrideTheme}
          onRowClick={(params) =>
            navigate(`/part-classifications/${params.row.id}`)
          }
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
              csvOptions: { fileName: 'classifications_demo' },
              printOptions: { fileName: 'classifications_demo' },
            },
          }}
        />
      </Box>
    </Paper>
  );
};

export default ClassificationHomeTemp;